<template>
  <roe-error-message :field="design.age_requirement_profit_sharing_years">
    <input
      type="number"
      v-model.number="design.$model.age_requirement_profit_sharing_years"
      required
      min="0"
    />
    <label class="input-label-inside">years</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherAgeRequirementYearsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
